<!--  -->
<template>
  <div class="price-info">
    <!-- 直降 -->
    <StraightDownPrice
      v-if="allAcvitityInfo.activeType === 1"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
      :productDetail="productDetail"
    />
    <!-- 秒杀 -->
    <SeckillPrice
      v-else-if="allAcvitityInfo.activeType === 2 || allAcvitityInfo.activeType === 3"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
      :productDetail="productDetail"
    />
    <!-- 优惠券 -->
    <CouponPrice
      v-else-if="allAcvitityInfo.activeType === 4"
      :nowAcvitity="allAcvitityInfo.nowAcvitity"
      :productDetail="productDetail"
    />

    <div class="price-box" v-else-if="allAcvitityInfo.activeType === 0" >
      <div class="price">
        <b v-if="productDetail.sellPrice">¥</b>
        <span>{{ productDetail.sellPrice || '限时免费' }}</span>
      </div>
      <span class="buy-count"
        >{{ productDetail.initialSales + productDetail.realSales }}人已抢购</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SeckillPrice from '../bookComponents/seckillPrice.vue';
import StraightDownPrice from '../bookComponents/straightDownPrice.vue';
import CouponPrice from '../bookComponents/couponPrice.vue';
import { reqproductDetailDiscount } from '@/api/courseDetail/courseAcvitity/index';
import { replaceHyphens } from '@/utils/tools';

export default {
  components: {
    SeckillPrice,
    StraightDownPrice,
    CouponPrice,
  },
  data() {
    return {
      salePrice: 0,
      allAcvitityInfo: {}, // 产品详情页所有的活动数据
      activeType: 0, // 活动类型  0无单品促销活动  1 直降 2 限时秒杀 3 限量秒杀  4优惠券  5 拼团 6分享
      nowAcvitity: {}, //  当前展示的活动信息
      currentTime: 0,
    };
  },
  props: {
    productDetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState([  'userInfo']),
  },
  watch: {
    userInfo() {
      // 登录成功后更新优惠券列表的领取状态（针对已领取的优惠券）
      this.getAcvitity();
    },
  },
  methods: {
    // 查询所有活动，优惠券和单品折扣活动同时存在的时候，已单品折扣为主
    async getAcvitity() {
      const {productSkuRespVOList}=this.productDetail;
      const {price,productSkuId,availableStock}=productSkuRespVOList?.[0]
      const res = await reqproductDetailDiscount({
        endPoint: this.$root.miniprogram ? 8 : this.$root.isApp ? 2 : 4,
        fitPlatform: 1,
        productId: this.$route.query.courseId,
        skuId: productSkuId,
        categoryId: this.productDetail.productCategoryId,
      });
      let activeType = 0;
      let nowAcvitity = {};
      if (res.code === 0) {
        this.currentTime = res.currentTime
          ? new Date(replaceHyphens(res.currentTime)).getTime()
          : new Date().getTime();
        const { productDetailSinglePromotionResp, couponDetailVO, productGroupActivityDiscount } =
          res.data;
        this.allAcvitityInfo = res?.data;
        // 秒杀,直降
        if (productDetailSinglePromotionResp) {
          let state = 0;
          const { stockType, stockNum } = productDetailSinglePromotionResp;
          activeType = productDetailSinglePromotionResp.promotionLabel;
          if (!productDetailSinglePromotionResp.startTime) {
            activeType = 0;
          } else if (
            productDetailSinglePromotionResp.showTime &&
            new Date(replaceHyphens(productDetailSinglePromotionResp.showTime)).getTime() >
              this.currentTime
          ) {
            // 未到活动展示时间
            activeType = 0;
          } else if (
            new Date(replaceHyphens(productDetailSinglePromotionResp.startTime)).getTime() >
            this.currentTime
          ) {
            // 未开始
            state = 0;
          } else if (
            this.currentTime >
              new Date(replaceHyphens(productDetailSinglePromotionResp.endTime)).getTime() ||
            (stockType === 2 && stockNum === 0)
          ) {
            // 已结束  //限量秒杀活动库存为0，隐藏活动
            state = 2;
            activeType = 0;
          } else {
            // 进行中
            state = 1;
          }
          nowAcvitity = productDetailSinglePromotionResp;
          Object.assign(productDetailSinglePromotionResp, {
            stockNum: stockType === 1 ? availableStock : stockNum,
            state,
          });
        } else {
          activeType = 0;
        }
        // 优惠券 免费课不展示券后价格
        if (
          activeType === 0 &&
          couponDetailVO &&
          couponDetailVO.couponId &&
          price
        ) {
          nowAcvitity = couponDetailVO;
          activeType = 4;
          Object.assign(couponDetailVO, {
            price,
            promotionPrice: (price - couponDetailVO.couponDiscount).toFixed(2),
          });
        }
        this.activeType = activeType;
        this.nowAcvitity = nowAcvitity;
      }
      Object.assign(this.allAcvitityInfo, { activeType, nowAcvitity });
      console.log(this.allAcvitityInfo,activeType,8888)
      this.saveAcvitity();
    },
    // 更新活动状态
    receiveGetActive() {
      this.getAcvitity();
    },
    // 活动保存到vuex
    saveAcvitity() {
      this.$store.dispatch('saveAllAcvitity', this.allAcvitityInfo);
    },
  },
  created() {},
  mounted() {
    this.getAcvitity();
  },
};
</script>
<style lang="scss" scoped>
.price-info{
  position: absolute;
  bottom: 0;
}
   .price-box {
        position: absolute;
        bottom: 0;
        left: 56px;
        display: flex;
        align-items: flex-end;
        .price {
          position: relative;
          z-index: 2;
          display: flex;
          flex-shrink: 0;
          align-items: center;
          width: 197px;
          height: 58px;
          padding-left: 56px;
          background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/ebook/price-bg.png?v=3')
            no-repeat;
          background-size: 100%;
          b {
            display: inline-block;
            color: #fff;
            font-weight: 600;
            font-size: 22px;
            line-height: 51px;
          }
          span {
            display: inline-block;
            color: #fff;
            font-weight: 600;
            font-size: 33px;
            line-height: 51px;
          }
        }
        .buy-count {
          position: relative;
          left: -25px;
          z-index: 1;
          flex-shrink: 0;
          width: fit-content;
          height: 38px;
          padding: 0 30px;
          color: #a9801a;
          font-weight: 500;
          font-size: 22px;
          line-height: 38px;
          background: linear-gradient(180deg, #fff7d4 0%, #ffeba9 100%);
          border: 2px solid #fff;
          border-radius: 11px;
        }
      }
</style>
